import React, { FC, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  makeStyles,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { omit } from 'lodash';
import parse from 'html-react-parser';

import { ContentEmailSpec, ContentEmailSpecInput, usePreviewContentEmailMutation } from 'api';
import { Loaders } from 'components';
import { useNotify } from 'hooks';

interface IProps {
  open: boolean;
  onClose: () => void;
  values: ContentEmailSpecInput | ContentEmailSpec;
}

const useStyles = makeStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  dialogContent: {
    minHeight: 500,
  },
}));

const PreviewDialog: FC<IProps> = ({ open, onClose, values }) => {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const notify = useNotify();

  const {
    mutate: previewEmail,
    data,
    isLoading,
  } = usePreviewContentEmailMutation({
    onError: notify.mutationError,
  });

  useEffect(() => {
    if (open) {
      previewEmail({ data: omit(values, ['id', 'created_at']) as ContentEmailSpecInput });
    }
  }, [open]);

  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth
      maxWidth="md"
      onClose={onClose}
      open={open}
      scroll={'paper'}
    >
      <DialogTitle disableTypography className={classes.root}>
        <Typography variant="h6">Email Preview</Typography>
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers className={classes.dialogContent}>
        {isLoading && <Loaders.Standard />}
        {!!data && <div>{parse(data.previewContentEmailSpec)}</div>}
      </DialogContent>
    </Dialog>
  );
};

export default PreviewDialog;
